import { useState, useEffect } from 'react';
import moment, { Moment } from 'moment';
import { Select, Typography } from 'antd';
import { RangePickerProps } from 'antd/lib/date-picker';
import { PeriodsEnum, useReportPeriodsOptions } from './hooks/useReportPeriodsOptions';
import { SelectBlueArrowIcon, DatePicker } from '@/components';
import classes from './ReportsFiltersByDate.module.scss';
import { ReportDto } from '@/core';

type ReportsFilterPropsType = {
  reports: ReportDto[];
  setReports: (reports: ReportDto[]) => void;
};

export const ReportsFiltersByDate = ({ reports, setReports }: ReportsFilterPropsType) => {
  const [selectedPeriod, setSelectedPeriod] = useState<string>(PeriodsEnum.All);
  const [startDate, setStartDate] = useState<Moment | null>(null);
  const [endDate, setEndDate] = useState<Moment | null>(null);
  const periodsOptions = useReportPeriodsOptions();

  useEffect(() => {
    if (startDate && endDate) {
      const filteredReportsByDate = reports.filter(({ createdAt }) =>
        moment(createdAt).isBetween(startDate, endDate, 'month', '[]'),
      );
      setReports(filteredReportsByDate);
      return;
    }
    if (selectedPeriod === PeriodsEnum.All) {
      setReports(reports);
    }
  }, [reports, startDate, endDate, setReports, selectedPeriod]);

  const onChangePeriod = (period: string) => {
    if (period === PeriodsEnum.Custom) {
      setSelectedPeriod(PeriodsEnum.Custom);
      setStartDate(null);
      setEndDate(null);
      return;
    }
    setSelectedPeriod(period);
    setStartDate(moment(new Date(period)));
    setEndDate(moment(new Date()));
  };

  const disabledDate: RangePickerProps['disabledDate'] = (current) => {
    return current > moment();
  };

  const onCalendarChange: RangePickerProps['onCalendarChange'] = (values, formatString, info) => {
    const [startDate, endDate] = values as Moment[];
    startDate && setStartDate(startDate.startOf('month'));
    endDate && setEndDate(endDate);
  };

  return (
    <div className={classes.filtersWrapper}>
      <div className={classes.filter}>
        <Typography.Text>Show reports</Typography.Text>
        <Select
          options={periodsOptions}
          value={selectedPeriod}
          suffixIcon={<SelectBlueArrowIcon />}
          className={classes.periodSelect}
          onChange={onChangePeriod}
        />
      </div>
      {selectedPeriod === PeriodsEnum.Custom ? (
        <DatePicker.RangePicker
          picker="month"
          value={[startDate, endDate]}
          className={classes.datePicker}
          allowClear={false}
          disabledDate={disabledDate}
          onCalendarChange={onCalendarChange}
        />
      ) : null}
    </div>
  );
};
